import { signalStore, withState } from '@ngrx/signals';
import { inject, InjectionToken } from '@angular/core';

export interface NavItem {
  name: string;
  path: string;
}

export interface NavigationState {
  items: NavItem[];
}

export const NAVIGATION_STATE = new InjectionToken<NavigationState>('navigation.state');

export const NavigationStateStore = signalStore(
  { providedIn: 'root' },
  withState(() => inject<NavigationState>(NAVIGATION_STATE)),
);
